import { render, staticRenderFns } from "./CrewExtraExperience.vue?vue&type=template&id=2b768638&scoped=true"
import script from "./CrewExtraExperience.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrewExtraExperience.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CrewExtraExperience.vue?vue&type=style&index=0&id=2b768638&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b768638",
  null
  
)

export default component.exports